import { Component } from '@angular/core';
import { ANEXO3_CUENTAS_OCULTAS } from '../../../services/excel/anexo3-cuentas-ocultas';
import { ANEXO4_CUENTAS_OCULTAS } from '../../../services/excel/anexo4-cuentas-ocultas';
import {
  NormativosExcelService,
  ConfigAnexo3,
  ConfigAnexo5,
  ConfigAnexo6,
  ConfigIndicadoresGlobales,
  ConfigActivosPonderados,
  DatoAnexo3,
  DatoAnexo4,
  DatoAnexo6,
  DatoIndicadorGlobal,
  DatoActivoPonderado,
  FilaResumenActivoPonderado,
  FilaCapitalInstitucional,
  TextosAnexoAnalitico,
  TextosAnexoCondensado,
  TextosIndicadoresGlobales,
  TextosActivosPonderados,
} from '../../../services/excel/normativos-excel.service';
import {
  ANEXO5_CELDAS,
  ANEXO5_COLS,
  ANEXO5_MERGES,
  ANEXO5_ESTILOS,
  EstiloA5,
} from '../../../services/excel/anexo5-template';
import { ANEXO6_CELDAS, CeldaAnexo6 } from '../../../services/excel/anexo6-template';
import { PARAMETROS_INDICADORES_GLOBALES, calcularRangoPuntaje } from '../../../services/excel/indicadores-globales-template';
import { messages } from '../../funciones/mensajes';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../../../services/data/data.service';
import { Apollo } from 'apollo-angular';
import { getCuentas, getEvaluaciones, getDetalleEvaluacionCuenta } from '../../../services/financiero/catalogo-cuentas/querys';
import { getIndicadores, getDetalleIndicadores } from '../../../services/financiero/indicadores-financieros/querys';
import { getCuenta } from '../../../services/financiero/estados-resultados/querys';
import { obtenerCodigoPropio, ObtenerIds, indicadores, activosPonderados } from '../../financiero-alerta/idsTablas';
import { periodos, FuncionesMes, calculos } from '../../funciones/funcionesGenerales';
import { CoberturaService } from '../../../services/financiero/cobertura/cobertura.service';
import { FiltersM } from '../../../components/models';
import { environment } from '../../../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { CatalogosService } from '../../../services/administrador-gestion/catalogos/catalogos.service';
import { companiesReportesNorm } from '../../../shared/catalogos';

interface CeldaPreviewA5 {
  row: number;
  col: number;
  colSpan: number;
  value: string;
  style: { [k: string]: string };
}

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrl: './reportes.component.css'
})
export class ReportesComponent {
  public Filters = FiltersM;
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  isLoading = false;
  tipoAnexo: string = 'anexo3';

  tituloAnexo: string = 'ANEXO 3';
  subtituloAnexo: string = 'BALANCE GENERAL ANALÍTICO';
  fechaInformacion: string = '';

  public Periodos = [];
  public cadenaEvaluacion = [];
  public subTitles = [];
  private maxPeriodos = 1;
  private idPlantilla = 0;
  private idInstitucion = 0;
  private evaluacionesRaw: any[] = [];
  public dataOrdenado: any[] = [];

  /** Institución activa según la cookie 'idInstitucion' (la que eligió el admin, o la propia). */
  private institucionActiva?: { id: string; name: string; idPlantilla: number; idAdmin: string };
  public cooperativa: string = '';

  private readonly LOGO_DEFAULT = '/assets/img/logoReporte.png';
  private logoInstitucion: string = '';

  /** Solo Chorotega usa estos 2 logos de gobierno en vez del logo de su cooperativa. */
  private readonly ID_INSTITUCION_LOGOS_GOBIERNO = 32;
  public readonly LOGO_GOBIERNO_HONDURAS = '/assets/img/logo-gobierno-honduras.png';
  public readonly LOGO_CONSEJO_COOPERATIVAS = '/assets/img/logo-consejo-cooperativas.png';
  /** true si hay que mostrar los logos de gobierno en vez del logo de la cooperativa. */
  public mostrarLogosGobierno = false;

  /** Cuentas del catálogo que no aplican a esta cooperativa; ocultas también en la vista previa. */
  public readonly anexo3CuentasOcultas = ANEXO3_CUENTAS_OCULTAS;
  public readonly anexo4CuentasOcultas = ANEXO4_CUENTAS_OCULTAS;

  datosAnexo3: DatoAnexo3[] = [];

  valoresAnexo5: { [codigo: string]: number } = {};

  datosAnexo4: DatoAnexo4[] = [];

  previewAnexo5: CeldaPreviewA5[] = [];
  readonly anexo5GridCols = Object.values(ANEXO5_COLS).map((w) => `${w}fr`).join(' ');

  readonly firmasPreview = [
    'reportes-normativos.firma-gerente',
    'reportes-normativos.firma-contador',
    'reportes-normativos.firma-auditor',
    'reportes-normativos.firma-presidente',
  ];

  valoresAnexo6: { [codigo: string]: number } = {};
  datosAnexo6: DatoAnexo6[] = [];

  datosIndicadoresGlobales: DatoIndicadorGlobal[] = [];

  datosActivosPonderados: DatoActivoPonderado[] = [];
  resumenActivosPonderados: FilaResumenActivoPonderado[] = [];
  totalResumenSumaActivos = 0;
  totalResumenPonderadoActivos = 0;
  capitalInstitucional: FilaCapitalInstitucional[] = [];

  constructor(
    private normativosExcelService: NormativosExcelService,
    private translate: TranslateService,
    readonly dataService: DataService,
    private apollo: Apollo,
    private cookieService: CookieService,
    private catalogosService: CatalogosService,
    private coberturaService: CoberturaService
  ) {
    this.idPlantilla = Number(this.cookieService.get('idPlanFin'));
    this.idInstitucion = Number(this.cookieService.get('idInstitucion'));
    this.institucionActiva = companiesReportesNorm.find(c => c.id === this.cookieService.get('idInstitucion'));
    this.mostrarLogosGobierno = this.idInstitucion === this.ID_INSTITUCION_LOGOS_GOBIERNO;
    // Nombre corto como respaldo mientras se resuelve la razón social completa.
    this.cooperativa = this.institucionActiva?.name || '';
    this.getEvaluacion();
    this.cargarDatosInstitucion();
    this.getIndicadoresGlobales();
  }

  /** Trae del backend del admin el logo y la razón social completa de la institución activa. */
  private async cargarDatosInstitucion(): Promise<void> {
    try {
      const idAdmin = this.institucionActiva?.idAdmin;
      if (!idAdmin) return;
      const inst: any = await firstValueFrom(this.catalogosService.getInstitucionesAdmin(idAdmin));
      const logo = inst?.logo || inst?.image || inst?.imageUrl || inst?.logoUrl || inst?.company_logo;
      if (logo) {
        this.logoInstitucion = logo;
      }
      if (inst?.company_name) {
        this.cooperativa = inst.company_name;
      }
    } catch {
    }
  }

  /** Trae el catálogo de indicadores de la plantilla y arma la lista de "Indicadores Globales". */
  private async getIndicadoresGlobales(): Promise<void> {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getIndicadores,
          context: { headers: this.headers },
          variables: { idPlantilla: this.idPlantilla }
        }).valueChanges.source
      );

      const datos = data.indicadores || [];
      let ordenIndi;
      switch (this.idPlantilla) {
        case 5:
          ordenIndi = indicadores.indiFinancieros5;
          break;
        case 12:
          ordenIndi = indicadores.indiFinancierosA;
          break;
        case 13:
          ordenIndi = indicadores.indiFinancieros13;
          break;
        default:
          ordenIndi = indicadores.indiFinancieros;
      }

      this.construirDatosIndicadoresGlobales(datos, ordenIndi);
    } catch {
    }
  }

  private construirDatosIndicadoresGlobales(datos: any[], ordenIndi: { name: string; pos: number }[]): void {
    const resultado: DatoIndicadorGlobal[] = [];
    let numMacro = 0;

    for (const ind of ordenIndi) {
      const indMac = datos.find((c: any) => c.id === ind.name);
      if (!indMac) continue;

      numMacro++;
      resultado.push({ nivel: 1, numero: `${numMacro}.`, descripcion: indMac.descripcion });

      const subIndicadores = datos
        .filter((c: any) => c.id.includes(indMac.id) && c.nivel === 3)
        .sort((a: any, b: any) => Number(a.id.split(indMac.id)[1]) - Number(b.id.split(indMac.id)[1]));

      subIndicadores.forEach((sub: any, idx: number) => {
        const numero = `${numMacro}.${idx + 1}`;
        resultado.push({
          nivel: 2,
          numero,
          descripcion: sub.descripcion,
          parametros: PARAMETROS_INDICADORES_GLOBALES[numero],
          id: sub.id,
        });
      });
    }

    this.datosIndicadoresGlobales = resultado;
    this.actualizarResultadosIndicadoresGlobales();
  }

  /** Llena RESULTADO de "Indicadores Globales" con el valor del período seleccionado.
   * Se llama al armar el catálogo y cada vez que cambia el período. */
  private async actualizarResultadosIndicadoresGlobales(): Promise<void> {
    if (!this.cadenaEvaluacion.length || !this.datosIndicadoresGlobales.length) return;
    try {
      const idEval = this.cadenaEvaluacion[this.cadenaEvaluacion.length - 1].id;
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getDetalleIndicadores,
          context: { headers: this.headers },
          variables: { idEvaluacion: idEval },
          fetchPolicy: 'network-only', // si no, Apollo puede servir la respuesta cacheada del período anterior
        }).valueChanges.source
      );
      const detalle: any[] = data.detalleEvaluacionIndicadors || [];

      this.datosIndicadoresGlobales = this.datosIndicadoresGlobales.map(dato => {
        if (dato.nivel !== 2) return dato;
        const det = detalle.find((d: any) => d.idIndicador === dato.id);
        if (!det) return dato;
        // valor ya viene en escala de porcentaje (4.21, no 0.0421), no se multiplica por 100.
        const valorPct = Number(det.valor);
        const tramo = calcularRangoPuntaje(dato.numero, valorPct);
        return {
          ...dato,
          resultado: valorPct.toFixed(2) + '%',
          rango: tramo?.rango,
          puntaje: tramo?.puntaje,
        };
      });
    } catch {
    }
  }

  private async getEvaluacion(): Promise<void> {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getEvaluaciones,
          context: { headers: this.headers },
          variables: { idPlantilla: this.idPlantilla }
        }).valueChanges.source
      );

      const aux = (data.evaluaciones || []).filter(
        (per: any) => per.idInstitucion === this.idInstitucion
      );
      this.evaluacionesRaw = aux;
      this.ordenamientoDataEvaluacion(aux);
    } catch {
    }
  }

  private ordenamientoDataEvaluacion(datos: any[]): void {
    const info = periodos.obtenerPeriodos(datos, this.maxPeriodos);
    this.Periodos = info.periodos;
    for (const an of this.Periodos) {
      if (an.anio < 2023) {
        an.utilizable = false;
      }
    }
    this.ultimasEvaluaciones();
  }

  private ultimasEvaluaciones(): void {
    this.cadenaEvaluacion = [];
    this.subTitles = [];
    let i = 0;
    for (const an of this.Periodos) {
      if (an.utilizable) {
        for (const mes of an.series) {
          if (mes.check) {
            this.cadenaEvaluacion.push({ evaluacion: mes.periodo, id: mes.id });
            if (i === 0) {
              this.subTitles.push(mes.periodo);
            } else {
              this.subTitles.push(' | ');
              this.subTitles.push(mes.periodo);
            }
            i++;
          }
        }
      }
    }
    this.getDetalleEvaluacion();
  }

  private async getDetalleEvaluacion(): Promise<void> {
    try {
      let datos: any[] = [];
      for (const eva of this.cadenaEvaluacion) {
        const { data } = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getDetalleEvaluacionCuenta,
            context: { headers: this.headers },
            variables: { idEvaluacion: eva.id }
          }).valueChanges.source
        );
        const aux = (data.detalleEvaluacionCuentas || []).map((d: any) => ({ per: eva.evaluacion, ...d }));
        datos = datos.concat(aux);
      }
      this.getCuentas(datos);
      this.actualizarResultadosIndicadoresGlobales();
      this.getActivosPonderados();
    } catch {
    }
  }

  /** Trae la tabla de Activos Ponderados por Riesgos (Anexo A) para el período
   * seleccionado. Cuentas, subtotales por tramo de riesgo y fórmulas encadenadas,
   * igual que la config de activosPonderados en idsTablas.ts. */
  private async getActivosPonderados(): Promise<void> {
    if (!this.cadenaEvaluacion.length) return;
    try {
      const cuentasAT = activosPonderados.cuentasAT(this.idPlantilla);
      if (!cuentasAT || Object.keys(cuentasAT).length === 0) return;

      const idEval = this.cadenaEvaluacion[this.cadenaEvaluacion.length - 1].id;
      const datos: any[] = [];
      await this.getCuentasActivosPonderados(cuentasAT['cuentas'], datos);
      await this.agregarSeriesActivosPonderados(cuentasAT['cuentas'], idEval, datos);
      const dataOrdenado = this.calcularTablaActivosPonderados(datos);
      this.construirDatosActivosPonderados(dataOrdenado);
    } catch {
    }
  }

  private async getCuentasActivosPonderados(cuentas: string[], cuentasTotal: any[]): Promise<void> {
    for (const id of cuentas) {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getCuenta,
          context: { headers: this.headers },
          variables: { cuentaId: id, idPlantilla: this.idPlantilla, params: { id, idPlantilla: this.idPlantilla } }
        }).valueChanges.source
      );
      cuentasTotal[data.cuenta.id] ??= [];
      cuentasTotal[data.cuenta.id].push({
        descripcion: data.cuenta.descripcion,
        id: data.cuenta.id,
        series: []
      });
    }
  }

  private async agregarSeriesActivosPonderados(cuentas: string[], idEval: number, cuentasTotal: any[]): Promise<void> {
    const resultados = await Promise.all(cuentas.map((id) => this.coberturaService.getDetalleCuenta(idEval, id)));
    resultados.forEach((r: any) => {
      const detalle = r?.detalleEvaluacionCuenta;
      if (!detalle) return;
      cuentasTotal[detalle.idCuenta][0].series.push(detalle);
    });
  }

  /** Arma la tabla de Activos Ponderados a partir de la config de idsTablas.ts:
   * cuentas, ajustes editables (siempre 0, no se persisten) y subtotales/totales
   * por fórmula (índices que apuntan a filas anteriores ya calculadas). */
  private calcularTablaActivosPonderados(data: any[]): any[][] {
    const numSeries = Object.values(data)[0][0].series;
    let posSuma: number, posSumaT: number, posTab: number, posAux: number;
    let dataTabla: any[][] = [], aux: any[] = [], genAux: any[] = [];

    for (let i = 0; ; i++) {
      const d = activosPonderados.tabla(this.idPlantilla, i);
      if (d === undefined) {
        break;
      } else if (d.codigo.includes('editable')) {
        const elementAux = { id: '', codigo: '', descripcion: d.descripcion, series: new Array(numSeries.length).fill({ valor: 0 }), edit: d.edit };
        aux.push(elementAux);
        genAux.push(elementAux);
      } else if (d.codigo === 'suma') {
        const arregloSumas = new Array(numSeries.length).fill({ valor: 0 });
        let posS = 0;
        if (d?.formula) {
          posSumaT = i;
          const c = d.formula.split(' ');
          let signo = '';
          dataTabla[0][0].series.forEach((s: any, iS: number) => {
            c.forEach((e: string) => {
              if (!isNaN(Number(e))) {
                arregloSumas[iS].valor = calculos.operations(arregloSumas[iS].valor, signo || '+', genAux[Number(e) - 1].series[iS].valor);
              } else {
                signo = e;
              }
            });
          });
        } else {
          for (const s of aux[0].series) {
            for (const n of aux) {
              arregloSumas[posS].valor += n.series[posS].valor;
            }
            posS++;
          }
        }
        const elementAux = { id: '', codigo: d.codigo, descripcion: d.descripcion, series: arregloSumas, edit: d.edit };
        aux.push(elementAux);
        genAux.push(elementAux);
        dataTabla.push(aux);
        aux = [];
      } else if (d.codigo === 'sumas') {
        posSuma = i;
        posTab = dataTabla.length;
        posAux = aux.length;
        const arregloSumas = new Array(numSeries.length).fill({ valor: 0 });
        // No es cuenta real: es lo que no quedó clasificado en los tramos anteriores.
        // La hoja oficial la muestra con un texto en la columna de código ("Resto de Activos").
        const elementAux = { id: '', codigo: 'sumaTexto', descripcion: d.descripcion, series: arregloSumas, edit: d.edit };
        aux.push(elementAux);
        genAux.push(elementAux);
      } else if (d.codigo.includes('total')) {
        if (this.idPlantilla === 13 && d.codigo === 'total') {
          const s = activosPonderados.tabla(this.idPlantilla, posSuma);
          let cn = s.formula.split(' ');
          let signo = '';
          const arreglo = new Array(numSeries.length).fill({ valor: 0 });
          dataTabla[0][0].series.forEach((s: any, iS: number) => {
            cn.forEach((e: string) => {
              if (!isNaN(Number(e))) {
                arreglo[iS].valor = calculos.operations(arreglo[iS].valor, signo || '+', genAux[Number(e) - 1].series[iS].valor);
              } else {
                signo = e;
              }
            });
          });
          dataTabla[posTab][posAux].series = arreglo;
          genAux[posSuma - 1].series = arreglo;

          const st = activosPonderados.tabla(this.idPlantilla, 58);
          cn = st.formula.split(' ');
          signo = '';
          const arregloSumasT = new Array(numSeries.length).fill({ valor: 0 });
          dataTabla[0][0].series.forEach((s: any, iS: number) => {
            cn.forEach((e: string) => {
              if (!isNaN(Number(e))) {
                arregloSumasT[iS].valor = calculos.operations(arregloSumasT[iS].valor, signo || '+', genAux[Number(e) - 1].series[iS].valor);
              } else {
                signo = e;
              }
            });
          });
          dataTabla[posTab][dataTabla[posTab].length - 1].series = arregloSumasT;
          genAux[posSumaT - 1].series = arregloSumasT;
        }
        const c2 = d.formula.split(' ');
        let signo = '';
        const arreglo = new Array(numSeries.length).fill({ valor: 0 });
        dataTabla[0][0].series.forEach((s: any, iS: number) => {
          c2.forEach((e: string) => {
            if (!isNaN(Number(e))) {
              arreglo[iS].valor = calculos.operations(arreglo[iS].valor, signo || '+', genAux[Number(e) - 1].series[iS].valor);
            } else {
              signo = e;
            }
          });
        });
        const elementAux = { id: '', codigo: 'total', descripcion: d.descripcion, series: arreglo, edit: d.edit };
        aux.push(elementAux);
        dataTabla.push(aux);
        genAux.push(elementAux);
        aux = [];
      } else if (d.codigo === 'titulo') {
        const elementAux = { id: '', codigo: d.codigo, descripcion: d.descripcion, series: new Array(numSeries.length).fill({ valor: 0 }), edit: d.edit };
        aux.push(elementAux);
        dataTabla.push(aux);
        aux = [];
      } else if (d.codigo === 'sub') {
        const s = activosPonderados.tabla(this.idPlantilla, i);
        let elementAux: any;
        const arreglo = new Array(numSeries.length).fill({ valor: 0 });
        if (s?.formula) {
          const cn = s.formula.split(' ');
          let signo = '';
          dataTabla[0][0].series.forEach((s: any, iS: number) => {
            cn.forEach((e: string) => {
              if (!isNaN(Number(e))) {
                const operando = !e.includes('.') ? genAux[Number(e) - 1].series[iS].valor : Number(e);
                arreglo[iS].valor = calculos.operations(arreglo[iS].valor, signo || '+', operando);
              } else {
                signo = e;
              }
            });
          });
          elementAux = { id: '', codigo: 'total', descripcion: d.descripcion, series: arreglo, edit: d.edit, porcentaje: d?.porcentaje };
        } else if (s?.cuenta) {
          elementAux = { id: '', codigo: 'total', descripcion: d.descripcion, series: data[d.cuenta][0].series, edit: d.edit };
        }
        aux.push(elementAux);
        genAux.push(elementAux);
        dataTabla.push(aux);
        aux = [];
      } else if (d.codigo === 'subcapital') {
        const sumaVI = new Array(numSeries.length).fill(0), operando1 = new Array(numSeries.length).fill(0);
        const arreglo = new Array(numSeries.length).fill({ valor: 0 });
        for (let k = 0; k < numSeries.length; k++) {
          sumaVI[k] = data['P302101'][0].series[k].valor + data['P302102'][0].series[k].valor + data['P302105'][0].series[k].valor +
            data['P302107'][0].series[k].valor + data['P302108'][0].series[k].valor;
          operando1[k] = data['P302109'][0].series[k].valor < 0 ? data['P302109'][0].series[k].valor : data['P302109'][0].series[k].valor / 2;
          arreglo[k].valor = sumaVI[k] + operando1[k];
        }
        const elementAux = { id: '', codigo: 'total', descripcion: d.descripcion, series: arreglo, edit: d.edit };
        aux.push(elementAux);
        genAux.push(elementAux);
        dataTabla.push(aux);
        aux = [];
      } else if (d.descripcion) {
        // Cuenta con descripción fija en la config (ej. "Total activo BG"): en la hoja
        // oficial se muestra como subencabezado dentro de la sección (código y
        // descripción resaltados), pero sí lleva su código propio y su valor real,
        // igual que cualquier cuenta. codigoMostrar usa el mismo mapeo que el resto
        // de las cuentas (obtenerCodigoPropio).
        const config = obtenerCodigoPropio.idsCodigoPropio(this.idPlantilla, d.codigo);
        const elementAux = { id: d.codigo, codigo: 'seccion', codigoMostrar: config?.codigo ?? '', descripcion: d.descripcion, series: data[d.codigo][0].series, edit: d.edit };
        aux.push(elementAux);
        genAux.push(elementAux);
      } else {
        const config = obtenerCodigoPropio.idsCodigoPropio(this.idPlantilla, d.codigo);
        const elementAux = { id: d.codigo, codigo: config?.codigo, descripcion: data[d.codigo][0].descripcion, series: data[d.codigo][0].series, edit: d.edit };
        aux.push(elementAux);
        genAux.push(elementAux);
      }
    }
    return dataTabla;
  }

  /** Aplana la tabla (venía agrupada por bloques) y la separa en sus 3 bloques: la
   * tabla principal por tramo de riesgo (I-VI), el resumen "Total de Activos
   * Ponderados por Riesgos" (suma y ponderado por tramo) y "Capital Institucional
   * Ajustado". El cálculo trae 3 "titulo" (portada, resumen y capital); esos 2
   * cortes son los que se usan para saber dónde empieza cada bloque. */
  private construirDatosActivosPonderados(dataOrdenado: any[][]): void {
    const filas = dataOrdenado.flat();
    const secciones = [0, 10, 20, 50, 100, 150].map((pct) =>
      this.translate.instant('reportes-normativos.seccion-' + pct)
    );
    const etiquetasResumen = [0, 10, 20, 50, 100, 150].map((pct) =>
      this.translate.instant('reportes-normativos.resumen-' + pct)
    );

    const datos: DatoActivoPonderado[] = [
      { codigo: '', descripcion: secciones[0], valor: 0, tipo: 'titulo' },
    ];
    const sumasCrudas: number[] = [];
    const ponderados: number[] = [];
    const capital: FilaCapitalInstitucional[] = [];
    let sumaCount = 0;
    let tituloCount = 0;
    let fase: 'principal' | 'resumen' | 'capital' = 'principal';
    let totalPonderado = 0;

    for (const fila of filas) {
      const valor = fila.series?.[0]?.valor ?? 0;

      if (fila.codigo === 'titulo') {
        tituloCount++;
        if (tituloCount === 2) fase = 'resumen';
        if (tituloCount === 3) fase = 'capital';
        continue;
      }

      if (fase === 'principal') {
        if (fila.codigo === 'suma') {
          datos.push({ codigo: '', descripcion: fila.descripcion, valor, tipo: 'destacado' });
          sumasCrudas.push(valor);
          sumaCount++;
          if (sumaCount < secciones.length) {
            datos.push({ codigo: '', descripcion: secciones[sumaCount], valor: 0, tipo: 'titulo' });
          }
        } else if (fila.codigo === 'total') {
          // El total general va en mayúsculas y con una fila en blanco antes, como en la hoja oficial.
          datos.push({ codigo: '', descripcion: (fila.descripcion || '').toUpperCase(), valor, tipo: 'total' });
        } else if (fila.codigo === 'seccion') {
          // Subencabezado dentro de la sección (ej. "Total activo BG"): sí lleva su
          // código y su valor real, igual que la hoja oficial (no es un banner vacío).
          datos.push({ codigo: fila.codigoMostrar || '', descripcion: fila.descripcion, valor, tipo: 'seccion' });
        } else if (fila.codigo === 'sumaTexto') {
          // No es cuenta real: en vez de dejar la columna de código vacía, muestra un
          // texto fijo ("1 Resto de Activos"), igual que en la hoja oficial. Solo ese
          // texto va en negrita, la descripción y el valor no.
          datos.push({
            codigo: this.translate.instant('reportes-normativos.resto-activos-codigo'),
            descripcion: fila.descripcion,
            valor,
            tipo: 'dato',
            codigoBold: true,
          });
        } else {
          datos.push({ codigo: fila.codigo || '', descripcion: fila.descripcion, valor, tipo: 'dato' });
        }
      } else if (fase === 'resumen') {
        if (ponderados.length < 6) {
          ponderados.push(valor);
        } else {
          totalPonderado = valor;
        }
      } else {
        capital.push({ descripcion: fila.descripcion, valor, porcentaje: fila.porcentaje });
      }
    }

    // "Exceso/Deficit de Capital del IAC Minimo" no viene del cálculo original del
    // tablero: es el total de capital institucional ajustado menos el mínimo requerido
    // (la última fila de este bloque, "10%"), igual que en la hoja oficial.
    const totalCapitalAjustado = capital.find((f) => /^total capital institucional ajustado/i.test(f.descripcion.trim()));
    const minimoRequerido = capital[capital.length - 1];
    if (totalCapitalAjustado && minimoRequerido) {
      capital.push({
        descripcion: this.translate.instant('reportes-normativos.exceso-deficit-iac'),
        valor: totalCapitalAjustado.valor - minimoRequerido.valor,
      });
    }

    this.datosActivosPonderados = datos;
    this.resumenActivosPonderados = etiquetasResumen.map((descripcion, i) => ({
      numero: i + 1,
      descripcion,
      suma: sumasCrudas[i] ?? 0,
      ponderado: ponderados[i] ?? 0,
    }));
    this.totalResumenSumaActivos = sumasCrudas.reduce((a, b) => a + b, 0);
    this.totalResumenPonderadoActivos = totalPonderado;
    this.capitalInstitucional = capital;
  }

  /** Usado en la vista previa para separar el bloque de Capital Institucional en 2
   * cajas: la primera termina en "Total capital institucional ajustado". */
  esFilaTotalCapital(descripcion: string): boolean {
    return /^total/i.test((descripcion || '').trim());
  }

  private async getCuentas(array: any[]): Promise<void> {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getCuentas,
          context: { headers: this.headers },
          variables: { idPlantilla: this.idPlantilla }
        }).valueChanges.source
      );

      const cuentas = data.cuentas || [];
      let aux: any[] = [];
      const levels: number[] = [];
      const lngLevels: number[] = [];
      let level = 0;

      for (const cuenta of cuentas) {
        const valores = array.filter((eva: any) => eva.idCuenta === cuenta.id);
        valores.sort((a: any, b: any) => a.idEvaluacion - b.idEvaluacion);

        const ex = lngLevels.indexOf(cuenta.id.length);
        if (ex === -1) {
          levels.push(levels.length + 1);
          lngLevels.push(cuenta.id.length);
          level = levels.length;
        } else {
          level = levels[ex];
        }

        const config = obtenerCodigoPropio.idsCodigoPropio(this.idPlantilla, cuenta.id);
        aux.push({
          id: cuenta.id,
          codigo: config?.codigo ?? cuenta.id,
          descripcion: cuenta.descripcion,
          series: valores,
          nivel: level,
          moneda: config?.moneda,
        });
      }

      // El Anexo 3 es el Balance General; las raíces 'I' (Ingresos) y 'G' (Gastos) son
      // del Anexo 4 y no van aquí, o desfasan las filas que vienen después.
      const cat = aux.filter(inf => inf.id.length === 2 && !inf.id.startsWith('I') && !inf.id.startsWith('G'));
      let aux2: any[] = [];
      for (const c of cat) {
        const elem = aux.filter(inf => inf.id.includes(c.id));
        aux2.push({ id: c.id, val: elem });
      }
      aux2.sort((a, b) => Number(a.id.substring(1)) - Number(b.id.substring(1)));
      aux = [];
      for (const v of aux2) {
        aux = aux.concat(v.val);
      }

      this.dataOrdenado = aux;
      this.construirDatosAnexo3(aux);
      this.construirValoresAnexo5(aux);
      this.construirCuentasAnexo4(cuentas, array);
      this.construirCuentasAnexo6(cuentas, array);
    } catch {
    }
  }

  private construirCuentasAnexo4(cuentas: any[], detalle: any[]): void {
    try {
      const aux: any[] = [];
      for (const cuenta of cuentas) {
        const info = ObtenerIds.idsCuentasP13(cuenta.id, 'ER');
        if (!info) continue;

        const valores = detalle.filter((eva: any) => eva.idCuenta === cuenta.id);
        valores.sort((a: any, b: any) => a.idEvaluacion - b.idEvaluacion);

        const config = obtenerCodigoPropio.idsCodigoPropio(this.idPlantilla, cuenta.id);
        aux.push({
          id: cuenta.id,
          codigo: config?.codigo ?? cuenta.id,
          descripcion: cuenta.descripcion,
          series: valores,
          nivel: info[0].nivel,
          pos: info[0].pos,
        });
      }
      aux.sort((a, b) => a.pos - b.pos);
      this.construirDatosAnexo4(aux);
    } catch {
    }
  }

  private construirDatosAnexo4(dataOrdenado: any[]): void {
    const ultimo = this.cadenaEvaluacion[this.cadenaEvaluacion.length - 1];
    const idEval = ultimo?.id;

    this.datosAnexo4 = dataOrdenado.map(item => {
      const dato: DatoAnexo4 = { codigo: item.codigo, descripcion: item.descripcion };
      const serie = item.series.find((s: any) => s.idEvaluacion === idEval) ?? item.series[item.series.length - 1];
      if (serie && item.nivel >= 1 && item.nivel <= 7) {
        (dato as any)['nivel' + item.nivel] = serie.valor;
      }
      return dato;
    });
  }

  private construirCuentasAnexo6(cuentas: any[], detalle: any[]): void {
    try {
      const ultimo = this.cadenaEvaluacion[this.cadenaEvaluacion.length - 1];
      const idEval = ultimo?.id;

      const valores: { [codigo: string]: number } = {};
      for (const cuenta of cuentas) {
        const infoMN = ObtenerIds.idsCuentasP13(cuenta.id, 'ER6MN');
        const infoME = ObtenerIds.idsCuentasP13(cuenta.id, 'ER6ME');
        if (!infoMN && !infoME) continue;

        const config = obtenerCodigoPropio.idsCodigoPropio(this.idPlantilla, cuenta.id);
        const codigo = config?.codigo;
        if (!codigo) continue;

        const valoresCuenta = detalle.filter((eva: any) => eva.idCuenta === cuenta.id);
        const serie = valoresCuenta.find((s: any) => s.idEvaluacion === idEval)
          ?? valoresCuenta[valoresCuenta.length - 1];
        if (serie && serie.valor != null) {
          valores[codigo] = Number(serie.valor);
        }
      }

      this.valoresAnexo6 = valores;
      this.construirPreviewAnexo6(valores);
    } catch {
    }
  }

  private construirPreviewAnexo6(valores: { [codigo: string]: number }): void {
    const porFila = new Map<number, { [col: string]: CeldaAnexo6 }>();
    for (const celda of ANEXO6_CELDAS) {
      const m = celda.ref.match(/^([A-G])(\d+)$/);
      if (!m) continue;
      const [, col, filaStr] = m;
      const fila = Number(filaStr);
      const info = porFila.get(fila) ?? {};
      info[col] = celda;
      porFila.set(fila, info);
    }

    const resueltos = new Map<string, number>();
    const resolverMonto = (celda?: CeldaAnexo6): number => {
      if (!celda) return 0;
      if (celda.k === 'f') return this.evaluarFormulaAnexo5(celda.f ?? '', resueltos);
      if (celda.k === 'lk') {
        const codigo = celda.code ?? '';
        return codigo ? (valores[codigo] ?? 0) : 0;
      }
      return 0;
    };

    const datos: DatoAnexo6[] = [];
    for (const fila of [...porFila.keys()].sort((a, b) => a - b)) {
      const cs = porFila.get(fila) ?? {};
      const descripcion = cs['A']?.v ?? '';
      const codigoMN = cs['B']?.v ?? '';
      const codigoME = cs['E']?.v ?? '';
      if (!descripcion && !codigoMN && !codigoME) continue;

      const total = resolverMonto(cs['C']);
      const monedaNacional = resolverMonto(cs['D']);
      const monedaExtranjera = resolverMonto(cs['F']);
      resueltos.set(`C${fila}`, total);

      datos.push({
        descripcion,
        cta: codigoMN,
        total: total || '',
        moneda_nacional: monedaNacional || '',
        cta_extranjera: codigoME,
        moneda_extranjera: monedaExtranjera || '',
      });
    }
    this.datosAnexo6 = datos;
  }

  private construirValoresAnexo5(dataOrdenado: any[]): void {
    try {
      const ultimo = this.cadenaEvaluacion[this.cadenaEvaluacion.length - 1];
      const idEval = ultimo?.id;

      const mapa: { [codigo: string]: number } = {};
      for (const item of dataOrdenado || []) {
        const codigo = item?.codigo;
        const series = item?.series;
        if (!codigo || !Array.isArray(series) || series.length === 0) continue;
        const serie = series.find((s: any) => s.idEvaluacion === idEval) ?? series[series.length - 1];
        if (serie && serie.valor != null) {
          mapa[codigo] = Number(serie.valor);
        }
      }
      this.valoresAnexo5 = mapa;
    } catch {
      this.valoresAnexo5 = {};
    }
    this.construirPreviewAnexo5();
  }

  private construirPreviewAnexo5(): void {
    const parseRef = (ref: string): { col: number; row: number } => {
      const m = ref.match(/^([A-L]+)(\d+)$/);
      const letras = m ? m[1] : 'A';
      const fila = m ? Number(m[2]) : 1;
      let col = 0;
      for (const ch of letras) {
        col = col * 26 + (ch.charCodeAt(0) - 64);
      }
      return { col, row: fila };
    };

    const colSpanPorRef = new Map<string, number>();
    const ocultarPorMerge = new Set<string>();
    for (const rango of ANEXO5_MERGES) {
      const [inicio, fin] = rango.split(':');
      const a = parseRef(inicio);
      const b = parseRef(fin);
      colSpanPorRef.set(inicio, b.col - a.col + 1);
      for (let c = a.col; c <= b.col; c++) {
        const ref = `${String.fromCharCode(64 + c)}${a.row}`;
        if (ref !== inicio) ocultarPorMerge.add(ref);
      }
    }

    const codigoPorFila = new Map<number, { activo?: string; pasivo?: string }>();
    for (const celda of ANEXO5_CELDAS) {
      const { col, row } = parseRef(celda.ref);
      if (celda.k !== 'v' || !celda.v) continue;
      if (col === 2) {
        codigoPorFila.set(row, { ...codigoPorFila.get(row), activo: celda.v });
      } else if (col === 8) {
        codigoPorFila.set(row, { ...codigoPorFila.get(row), pasivo: celda.v });
      }
    }
    const nivelDeCodigo = (codigo?: string): number => {
      const len = (codigo ?? '').trim().length;
      if (len === 3) return 1;
      if (len === 6) return 2;
      return 0;
    };

    const cooperativa = this.cooperativa;
    const valoresResueltos = new Map<string, number>();
    const celdas: CeldaPreviewA5[] = [];

    for (const celda of ANEXO5_CELDAS) {
      if (ocultarPorMerge.has(celda.ref)) continue;
      const { col, row } = parseRef(celda.ref);

      let texto = '';
      if (celda.ph === 'titulo') {
        texto = this.translate.instant('reportes-normativos.titulo-anexo5');
      } else if (celda.ph === 'subtitulo') {
        texto = this.translate.instant('reportes-normativos.subtitulo-anexo5');
      } else if (celda.ph === 'cooperativa') {
        texto = cooperativa;
      } else if (celda.ph === 'fecha') {
        texto = this.fechaConNombreMes(this.fechaInformacion || '31/10/2025');
      } else if (celda.k === 'lk') {
        const monto = (this.valoresAnexo5[celda.code ?? ''] ?? 0) * (celda.sign ?? 1);
        valoresResueltos.set(celda.ref, monto);
        texto = monto ? monto.toLocaleString('es-HN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
      } else if (celda.k === 'f') {
        const monto = this.evaluarFormulaAnexo5(celda.f ?? '', valoresResueltos);
        valoresResueltos.set(celda.ref, monto);
        texto = monto ? monto.toLocaleString('es-HN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
      } else {
        texto = celda.v ?? '';
      }

      const style = this.estiloA5AEstiloCss(ANEXO5_ESTILOS[celda.s]);

      if (col === 1 || col === 7) {
        const codigo = col === 1 ? codigoPorFila.get(row)?.activo : codigoPorFila.get(row)?.pasivo;
        const nivel = nivelDeCodigo(codigo);
        if (nivel === 1) {
          style['font-weight'] = 'bold';
        } else if (nivel === 2) {
          style['padding-left'] = '20px';
        }
      }

      celdas.push({
        row,
        col,
        colSpan: colSpanPorRef.get(celda.ref) ?? 1,
        value: texto,
        style,
      });
    }

    this.previewAnexo5 = celdas;
  }

  /** Fórmulas simples de la plantilla del Anexo 5: SUM(rango) y sumas/restas entre celdas. */
  private evaluarFormulaAnexo5(formula: string, valoresResueltos: Map<string, number>): number {
    const tokens = formula.match(/[+-]|SUM\([A-Z]+\d+:[A-Z]+\d+\)|[A-Z]+\d+/g) ?? [];
    let total = 0;
    let signo = 1;
    for (const tok of tokens) {
      if (tok === '+') { signo = 1; continue; }
      if (tok === '-') { signo = -1; continue; }
      const rango = tok.match(/^SUM\(([A-Z]+)(\d+):[A-Z]+(\d+)\)$/);
      if (rango) {
        const [, col, r1, r2] = rango;
        let suma = 0;
        for (let r = Number(r1); r <= Number(r2); r++) {
          suma += valoresResueltos.get(`${col}${r}`) ?? 0;
        }
        total += signo * suma;
      } else {
        total += signo * (valoresResueltos.get(tok) ?? 0);
      }
    }
    return total;
  }

  private estiloA5AEstiloCss(e: EstiloA5 | undefined): { [k: string]: string } {
    if (!e) return {};
    const css: { [k: string]: string } = {
      'font-family': e.font.name,
      'font-size.px': String(Math.round(e.font.size * 0.72)),
      'font-weight': e.font.bold ? 'bold' : 'normal',
    };
    if (e.font.color) css['color'] = '#' + e.font.color.slice(2);
    if (e.fill) css['background-color'] = '#' + e.fill.slice(2);
    if (e.align?.h) css['text-align'] = e.align.h;
    if (e.align?.wrap) css['white-space'] = 'normal';
    if (e.numFmt && e.numFmt.includes('/')) css['white-space'] = 'nowrap';
    const borde = '1px solid #3F3F3F';
    if (e.border?.t) css['border-top'] = borde;
    if (e.border?.b) css['border-bottom'] = borde;
    if (e.border?.l) css['border-left'] = borde;
    if (e.border?.r) css['border-right'] = borde;
    return css;
  }

  private construirDatosAnexo3(dataOrdenado: any[]): void {
    const ultimo = this.cadenaEvaluacion[this.cadenaEvaluacion.length - 1];
    const idEval = ultimo?.id;

    const evalRaw = this.evaluacionesRaw.find(e => e.id === idEval);
    if (evalRaw) {
      this.fechaInformacion = this.ultimoDiaDelPeriodo(evalRaw.fechaContable);
    }

    this.datosAnexo3 = dataOrdenado.map(item => {
      const dato: DatoAnexo3 = { codigo: item.codigo, descripcion: item.descripcion };
      const serie = item.series.find((s: any) => s.idEvaluacion === idEval) ?? item.series[item.series.length - 1];
      if (serie && item.nivel >= 1 && item.nivel <= 8) {
        (dato as any)['nivel' + item.nivel] = serie.valor;
      }
      return dato;
    });
  }

  /** Solo se puede tener un período seleccionado a la vez (selección tipo radio). */
  public cambioPeriodo(per: any): void {
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        mes.check = false;
      }
    }
    per.check = true;

    this.cadenaEvaluacion = [{ evaluacion: per.periodo, id: per.id }];
    this.subTitles = [per.periodo];
    this.getDetalleEvaluacion();
  }

  public escrituraPer(periodo: string): string {
    if (periodo && periodo.split(' ').length === 2) {
      const datos = periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    }
    return periodo;
  }

  /** Último día del mes del período (ej. período de julio 2025 -> 31/07/2025), sin importar el día que traiga fechaContable. */
  private ultimoDiaDelPeriodo(fecha: any): string {
    if (!fecha) return '';
    const s = String(fecha);
    const yyyy = Number(s.substring(0, 4));
    const mm = Number(s.substring(5, 7));
    if (!yyyy || !mm) return '';
    const ultimoDia = new Date(yyyy, mm, 0).getDate();
    return `${String(ultimoDia).padStart(2, '0')}/${String(mm).padStart(2, '0')}/${yyyy}`;
  }

  /** Convierte "dd/mm/yyyy" a "dd/<mes>/yyyy" (nombre del mes, no el número). */
  public fechaConNombreMes(fecha: string): string {
    if (!fecha || fecha.split('/').length !== 3) return fecha || '';
    const [dd, mm, yyyy] = fecha.split('/');
    return `${dd}/${FuncionesMes.f_switchmes(mm)}/${yyyy}`;
  }

  /** "31 DE OCTUBRE DE 2025", mismo formato que usa el Excel de Indicadores Globales. */
  public fechaEnLetras(fecha: string): string {
    return this.normativosExcelService.fechaEnLetras(fecha);
  }

  onTipoAnexoChange(): void {
    switch (this.tipoAnexo) {
      case 'anexo3':
        this.tituloAnexo = this.translate.instant('reportes-normativos.titulo-anexo3');
        this.subtituloAnexo = this.translate.instant('reportes-normativos.subtitulo-anexo3');
        break;
      case 'anexo4':
        this.tituloAnexo = this.translate.instant('reportes-normativos.titulo-anexo4');
        this.subtituloAnexo = this.translate.instant('reportes-normativos.subtitulo-anexo4');
        break;
      case 'anexo5':
        this.tituloAnexo = this.translate.instant('reportes-normativos.titulo-anexo5');
        this.subtituloAnexo = this.translate.instant('reportes-normativos.subtitulo-anexo5');
        break;
      case 'anexo6':
        this.tituloAnexo = this.translate.instant('reportes-normativos.titulo-anexo6');
        this.subtituloAnexo = this.translate.instant('reportes-normativos.subtitulo-anexo6');
        break;
      case 'globales':
        this.tituloAnexo = this.translate.instant('reportes-normativos.titulo-globales');
        this.subtituloAnexo = '';
        break;
      case 'activosPonderados':
        this.tituloAnexo = this.translate.instant('reportes-normativos.titulo-activos-ponderados');
        this.subtituloAnexo = '';
        break;
      default:
        this.tituloAnexo = this.translate.instant('reportes-normativos.titulo-anexo3');
        this.subtituloAnexo = this.translate.instant('reportes-normativos.subtitulo-anexo3');
    }
  }

  /** Traduce firmasPreview (claves de es.json) a los textos reales, para
   * pasarlos al generador de Excel (que no tiene TranslateService). */
  private firmasTraducidas(): string[] {
    return this.firmasPreview.map((clave) => this.translate.instant(clave));
  }

  private textosAnexoAnalitico(): TextosAnexoAnalitico {
    return {
      colCodigo: this.translate.instant('reportes-normativos.col-codigo'),
      colDescripcion: this.translate.instant('reportes-normativos.col-descripcion'),
      cooperativaLabel: this.translate.instant('reportes-normativos.cooperativa-label'),
      fechaInformacionLabel: this.translate.instant('reportes-normativos.fecha-informacion-label'),
      tipoLabel: this.translate.instant('reportes-normativos.tipo-label'),
      variosElementos: this.translate.instant('reportes-normativos.varios-elementos'),
      cifrasLempiras: this.translate.instant('reportes-normativos.cifras-lempiras'),
      nivelLabel: this.translate.instant('reportes-normativos.nivel-label'),
      firmas: this.firmasTraducidas(),
    };
  }

  private textosAnexoCondensado(): TextosAnexoCondensado {
    return {
      cooperativaLabel: this.translate.instant('reportes-normativos.cooperativa-label'),
      fechaInformacionLabel: this.translate.instant('reportes-normativos.fecha-informacion-label'),
      cifrasLempiras: this.translate.instant('reportes-normativos.cifras-lempiras'),
      colCta: this.translate.instant('reportes-normativos.col-cta'),
      colTotal: this.translate.instant('reportes-normativos.col-total'),
      colMonedaNacional: this.translate.instant('reportes-normativos.col-moneda-nacional'),
      colMonedaExtranjera: this.translate.instant('reportes-normativos.col-moneda-extranjera'),
      firmas: this.firmasTraducidas(),
    };
  }

  private textosIndicadoresGlobales(): TextosIndicadoresGlobales {
    return {
      consejoNacional: this.translate.instant('reportes-normativos.consejo-nacional'),
      superintendencia: this.translate.instant('reportes-normativos.superintendencia'),
      tituloGlobales: this.translate.instant('reportes-normativos.titulo-globales'),
      cifrasAl: this.translate.instant('reportes-normativos.cifras-al'),
      colIndicador: this.translate.instant('reportes-normativos.col-indicador'),
      colParametros: this.translate.instant('reportes-normativos.col-parametros'),
      colResultado: this.translate.instant('reportes-normativos.col-resultado'),
      colRango: this.translate.instant('reportes-normativos.col-rango'),
      colPuntaje: this.translate.instant('reportes-normativos.col-puntaje'),
      sumatoriaBase: this.translate.instant('reportes-normativos.sumatoria-base'),
      calificacionBase: this.translate.instant('reportes-normativos.calificacion-base'),
      nivelRiesgoLabel: this.translate.instant('reportes-normativos.nivel-riesgo'),
      elaboradoPor: this.translate.instant('reportes-normativos.elaborado-por'),
      autorizadoGerente: this.translate.instant('reportes-normativos.autorizado-gerente'),
    };
  }

  private textosActivosPonderados(): TextosActivosPonderados {
    return {
      titulo: this.translate.instant('reportes-normativos.titulo-activos-ponderados'),
      resumenTitulo: this.translate.instant('reportes-normativos.resumen-titulo'),
      colSumaActivos: this.translate.instant('reportes-normativos.col-suma-activos'),
      colActivosPonderados: this.translate.instant('reportes-normativos.col-activos-ponderados'),
      totalesLabel: this.translate.instant('reportes-normativos.totales-label'),
      capitalInstitucionalTitulo: this.translate.instant('reportes-normativos.capital-institucional-titulo'),
      elaboradoPor: this.translate.instant('reportes-normativos.elaborado-por'),
      autorizadoPor: this.translate.instant('reportes-normativos.autorizado-por'),
    };
  }

  async generarAnexo3(): Promise<void> {
    this.isLoading = true;

    try {
      messages.messageSaving(
        this.translate.instant('reportes-normativos.generando'),
        this.translate.instant('reportes-normativos.generando-desc')
      );

      const cooperativa = this.cooperativa;
      const imagePath = this.logoInstitucion || this.LOGO_DEFAULT;
      // Solo Chorotega cambia a los logos de gobierno; el resto usa su propio logo.
      const imagePathFinal = this.mostrarLogosGobierno ? this.LOGO_GOBIERNO_HONDURAS : imagePath;
      const imagePath2 = this.mostrarLogosGobierno ? this.LOGO_CONSEJO_COOPERATIVAS : undefined;

      if (this.tipoAnexo === 'anexo5') {
        const configA5: ConfigAnexo5 = {
          titulo: this.translate.instant('reportes-normativos.titulo-anexo5'),
          subtitulo: this.translate.instant('reportes-normativos.subtitulo-anexo5'),
          cooperativa: cooperativa,
          fechaInformacion: this.fechaInformacion || '31/10/2025',
          valores: this.valoresAnexo5,
          nombreArchivo: 'Anexo5_BG.xlsx',
          imagePath: imagePathFinal,
          imagePath2: imagePath2,
          firmas: this.firmasTraducidas(),
        };
        await this.normativosExcelService.generateAnexo5(configA5);
        messages.succesMessageGraph(this.translate.instant('reportes-normativos.exito-generar'));
        return;
      }

      if (this.tipoAnexo === 'anexo4') {
        await this.normativosExcelService.generateAnexo4({
          titulo: this.translate.instant('reportes-normativos.titulo-anexo4'),
          subtitulo: this.translate.instant('reportes-normativos.subtitulo-anexo4'),
          cooperativa: cooperativa,
          fechaInformacion: this.fechaInformacion || '31/10/2025',
          datos: this.datosAnexo4,
          nombreArchivo: 'Anexo4_ER.xlsx',
          imagePath: imagePathFinal,
          imagePath2: imagePath2,
          textos: this.textosAnexoAnalitico(),
        });
        messages.succesMessageGraph(this.translate.instant('reportes-normativos.exito-generar'));
        return;
      }

      if (this.tipoAnexo === 'anexo6') {
        const configA6: ConfigAnexo6 = {
          titulo: this.translate.instant('reportes-normativos.titulo-anexo6'),
          subtitulo: this.translate.instant('reportes-normativos.subtitulo-anexo6'),
          cooperativa: cooperativa,
          fechaInformacion: this.fechaInformacion || '31/10/2025',
          valores: this.valoresAnexo6,
          nombreArchivo: 'Anexo6_ER.xlsx',
          imagePath: imagePathFinal,
          imagePath2: imagePath2,
          textos: this.textosAnexoCondensado(),
        };
        await this.normativosExcelService.generateAnexo6(configA6);
        messages.succesMessageGraph(this.translate.instant('reportes-normativos.exito-generar'));
        return;
      }

      if (this.tipoAnexo === 'activosPonderados') {
        const configAP: ConfigActivosPonderados = {
          datos: this.datosActivosPonderados,
          resumenPonderados: this.resumenActivosPonderados,
          totalResumenSuma: this.totalResumenSumaActivos,
          totalResumenPonderado: this.totalResumenPonderadoActivos,
          capitalInstitucional: this.capitalInstitucional,
          nombreArchivo: 'AnexoA_Ponderados.xlsx',
          imagePath: imagePathFinal,
          imagePath2: imagePath2,
          textos: this.textosActivosPonderados(),
        };
        await this.normativosExcelService.generateActivosPonderados(configAP);
        messages.succesMessageGraph(this.translate.instant('reportes-normativos.exito-generar'));
        return;
      }

      if (this.tipoAnexo === 'globales') {
        const configGlobales: ConfigIndicadoresGlobales = {
          cooperativa: cooperativa,
          fechaInformacion: this.fechaInformacion || '31/10/2025',
          datos: this.datosIndicadoresGlobales,
          nombreArchivo: 'IndicadoresGlobales.xlsx',
          imagePath: imagePathFinal,
          imagePath2: imagePath2,
          textos: this.textosIndicadoresGlobales(),
        };
        await this.normativosExcelService.generateIndicadoresGlobales(configGlobales);
        messages.succesMessageGraph(this.translate.instant('reportes-normativos.exito-generar'));
        return;
      }

      const titulo = this.translate.instant('reportes-normativos.titulo-anexo3');
      const subtitulo = this.translate.instant('reportes-normativos.subtitulo-anexo3');
      const nombreArchivo = 'Anexo3_BG.xlsx';

      const config: ConfigAnexo3 = {
        titulo: titulo,
        subtitulo: subtitulo,
        cooperativa: cooperativa,
        fechaInformacion: this.fechaInformacion || '31/10/2025',
        datos: this.datosAnexo3,
        nombreArchivo: nombreArchivo,
        imagePath: imagePathFinal,
        imagePath2: imagePath2,
        textos: this.textosAnexoAnalitico(),
      };

      await this.normativosExcelService.generateAnexo3(config);

      messages.succesMessageGraph(this.translate.instant('reportes-normativos.exito-generar'));
    } catch (error) {
      messages.errorMessageGraph(this.translate.instant('reportes-normativos.error-generar') + ': ' + error);
    } finally {
      this.isLoading = false;
    }
  }
}
